/**
 * useSessionMostRecentlyUpdatedModelPageContext
 *
 * Returns the most recently updated model's full page context
 * (page, size, sort, order) reactively from Redux state.
 *
 * Backed by the session RTK Slice.
 *
 * @see src/store/slices/sessionSlice.ts
 */
import { useAppSelector } from '@/store/hooks';
import { selectMostRecentlyUpdatedModelPage } from '@/store/slices/sessionSlice';
export const useSessionMostRecentlyUpdatedModelPageContext = () => {
    const page = useAppSelector(selectMostRecentlyUpdatedModelPage);
    return page !== null && page !== void 0 ? page : undefined;
};
